import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { ConvencoesSindicaisComponent } from './convencoes-sindicais.component';

@NgModule({
  declarations: [ConvencoesSindicaisComponent],
  imports: [
    CommonModule,
    FormsModule,
    PoModule
  ],
  exports: [ConvencoesSindicaisComponent]
})
export class ConvencoesSindicaisModule { }
